<script setup>
import { toRef } from 'vue';
import { useRsvpStore } from '@/stores/rsvp/rsvp.store';

const rsvpStore = useRsvpStore();

const headerTextFont =
  rsvpStore.clientData.common.headerTextFont &&
  rsvpStore.clientData.common.headerTextFont.trim() !== ''
    ? rsvpStore.clientData.common.headerTextFont
    : 'Great Vibes';
const textFont =
  rsvpStore.clientData.common.textFont &&
  rsvpStore.clientData.common.textFont.trim() !== ''
    ? rsvpStore.clientData.common.textFont
    : 'Alegreya';
const textFontB =
  rsvpStore.clientData.common.textFont &&
  rsvpStore.clientData.common.textFont.trim() !== ''
    ? rsvpStore.clientData.common.textFont
    : 'Lato';

const formattedDueToText = toRef(() =>
  rsvpStore.getLangData('formattedDueToText'),
);
</script>

<template>
  <div id="rsvp-form" class="form">
    <p>
      <b
        v-if="rsvpStore.getLangAllLangData().form.confirmArrival"
        class="confirm"
      >
        {{ rsvpStore.getLangAllLangData().form.confirmArrival }}
      </b>
      <b v-else class="confirm">
        {{ $t('appCore.apps.rsvp.components.form.verions.2.confirmArrival') }}
      </b>
    </p>
    <p v-if="rsvpStore.getLangAllLangData().form.arrivalText" class="form-info">
      {{ rsvpStore.getLangAllLangData().form.arrivalText }}
    </p>
    <p v-else class="form-info">
      {{ $t('appCore.apps.rsvp.components.form.verions.2.historyWish') }}
    </p>
    <i18n-t
      v-if="!rsvpStore.getLangAllLangData().form.arrivalText"
      class="form-info"
      keypath="appCore.apps.rsvp.components.form.verions.2.dueToInfo"
      tag="p"
      scope="global"
    >
      <template #dueToTime>
        <b>{{ formattedDueToText }}</b>
      </template>
    </i18n-t>
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styleConstans';

.form {
  position: relative;
  width: 90%;
  max-width: 650px;
  display: flex;
  flex-direction: column;
  gap: 35px;
  text-align: center;
  margin: 60px auto;
  font-size: 16px;

  .confirm {
    font-size: 4em;
    line-height: 1em;
    line-height: normal;
    font-family: v-bind(headerTextFont), cursive;

    @media screen and (max-width: $media-phone) {
      font-size: 3em;
    }
  }

  .form-info {
    font-size: 1.4em;
    font-weight: 300;
    line-height: normal;
    font-family: v-bind(textFont), sans-serif;

    @media screen and (max-width: $media-phone) {
      font-size: 1.25em;
    }

    b {
      font-weight: 700;
      font-family: v-bind(textFontB), serif;
      text-wrap: nowrap;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
